import React from "react"
import ReactDOM from "react-dom"
import LinkList from "./link-list-component"

export default class LinkListModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<LinkList {...self.modelJson} />, self.elem)
  }
}
